import { useCallback } from 'react';

const cache = new Map<string, unknown>();

const generateCacheKey = (objectOrString: unknown): string => {
    return typeof objectOrString === 'string'
        ? objectOrString
        : JSON.stringify(objectOrString);
};

export const useGlobalCache = () => {
    const get = useCallback(<T>(objectOrString: unknown): T | null => {
        const key = generateCacheKey(objectOrString);
        return cache.get(key) as T | null;
    }, []);

    const set = useCallback((objectOrString: unknown, value: unknown) => {
        const key = generateCacheKey(objectOrString);
        cache.set(key, value);
    }, []);

    const clear = useCallback(() => {
        cache.clear();
    }, []);

    return {
        get,
        set,
        clear,
    };
};
